module.exports = __webpack_public_path__ + "static/media/clientLogo.3d9c5140.png";